import { useCallback } from "react";
import {
  CHAT_BRIDGE_ACTIVE_KEY,
  CHAT_BRIDGE_EVENT,
  CHAT_BRIDGE_QUEUE_KEY,
  type BridgeMessage,
} from "./chatBridge";

/**
 * Workspace-level chat bridge — dispatches messages to ChatSpine
 * from anywhere in the workspace (presence elements, Life cards, sidebar).
 *
 * Uses the same custom DOM event pattern as WorkspaceShell's
 * `mock-workspace-updated` listener (WorkspaceShell.tsx:97).
 */
export function useChatBridge() {
  const sendChatMessage = useCallback((text: string, context?: Record<string, unknown>) => {
    const payload: BridgeMessage = {
      id: `bridge-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      text,
      context,
    };
    const bridgeWindow = window as Window & {
      [CHAT_BRIDGE_ACTIVE_KEY]?: boolean;
      [CHAT_BRIDGE_QUEUE_KEY]?: BridgeMessage[];
    };

    const queue = bridgeWindow[CHAT_BRIDGE_QUEUE_KEY];
    if (Array.isArray(queue)) {
      queue.push(payload);
    } else {
      bridgeWindow[CHAT_BRIDGE_QUEUE_KEY] = [payload];
    }

    if (bridgeWindow[CHAT_BRIDGE_ACTIVE_KEY]) {
      window.dispatchEvent(new CustomEvent(CHAT_BRIDGE_EVENT, { detail: payload }));
    }
  }, []);

  return { sendChatMessage };
}
